<template>
    <div id="testPaperList" class="app-inner">
         <div class="public-btn-div flex align-cen" v-if="!topicID && !importName">
            <div class="public-add" @click="addPaper">
            新增试卷
      </div>
         </div>
            <div class="p-tit-c">
        <div class="businessList-filter">
              <div class="businessList-filter-list flex align-cen">
                     <div class="fl-le flex align-cen">
          <div class="label">试卷名称：</div>
          <div class="el-select1">
            <el-input placeholder="请输入试卷名称" v-model="search" clearable> </el-input>
          </div>
         </div>
          <div class="fl-rt flex align-cen">
          <div class="label">试卷ID：</div>
          <div class="el-select1">
          <el-input placeholder="请输入试卷ID" v-model="search1" clearable> </el-input>
          </div>
         </div>
              </div>
       <div class="businessList-filter-list flex align-cen">
              <div class="fl-le flex align-cen">
          <div class="label">试卷分类：</div>
          <el-cascader
                :options="itemList"
                v-model="value"
                separator="--"
                clearable
                @change="classSelect1"
                change-on-select
                 ref="cascaderRef"
                >
            </el-cascader>
        </div>
      </div>
             <div class="businessList-filter-list flex align-cen" v-if="importName">
              <div class="fl-le flex align-cen">
          <div class="label">练习试卷：</div>
                     <el-select
                        v-model="value1"
                        clearable
                        placeholder="请选择"
                        @change="classSelect"
                    >
                        <el-option
                        v-for="item in opetion"
                          :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
            </el-option>
          </el-select>
        </div>
      </div>
        <div class="businessList-filter-list flex align-cen" v-if="!importName">
        <div class="label">考试时间：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allradio(0)"
        >
          不限
        </div>
        <el-radio v-model="radio" label="1" @change="classSelect" >有时间限制</el-radio>
        <el-radio v-model="radio" label="2" @change="classSelect">无时间限制</el-radio>
      </div>
       <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="classSelect">
        搜索
        </div>
        <div class="public-btn-small-text" @click="reset"> 
        重置筛选条件
        </div>
      </div>
        </div>
            </div>
                <!-- <iframe src="/report_hongfeng_6.html" ref="iframe" width="100%" height="1000"></iframe> -->
              <div class="businessList-container">
        <div class="businessList-container-table">
                  <el-table
            ref="multipleTable"
            :data="list"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                   :row-key="getRowKeyOfTarget"
          @selection-change="handleSelectionChange"
          @select='onTableSelect'
            >
          <el-table-column type="selection" width="55" reserve-selection v-if="importName"> 
         </el-table-column>
            <el-table-column label="试卷封面" align="center" prop="pic">
            <template slot-scope="scope" >
                <img :src="scope.row.logo ? scope.row.logo : require('../../../assets/images/nullimg.png')" alt="" style="display: block;width:50%;margin:0 auto" v-if="scope.row.id !=0"> 
            </template>
         </el-table-column>
            <el-table-column prop="id" label="试卷ID" align="center" width="200">
          </el-table-column>
           <el-table-column prop="paperName" label="试卷名称" align="center" width="300">
          </el-table-column>
          <el-table-column prop="classifyName" label="试卷分类" align="center" >
          </el-table-column>
          <el-table-column prop="examNum" label="考试人次" align="center" >
          </el-table-column>
           <el-table-column prop="" label="考试时间" align="center" >
             <template slot-scope="scope">
              <div>
                {{scope.row.answerTimeLimit ? `${scope.row.answerTimeLimit}分钟` : '-'}}
              </div>
             </template>
          </el-table-column>
           <el-table-column prop="questionNum" label="题目数" align="center" >
          </el-table-column>
              <el-table-column prop="" label="练习试卷" align="center" v-if="importName">
             <template slot-scope="scope">
              <div>
                {{scope.row.practiceMode == 1 || scope.row.practiceMode == 2 ? '是' : '否'}} 
              </div>
             </template>
          </el-table-column>
          <el-table-column label="状态" align="center" v-if="!importName">
            <template slot-scope="scope">
              <div class="buStatus" @click="changeStatus(scope)">
                <el-switch
                  v-model="scope.row.state == 2 ? false : true"
                  disabled
                >
                </el-switch>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="350"
            v-if="!topicID && !importName"
            >
             <template slot-scope="scope">
                 <el-button type="text" size="small"  slot="reference" style="color:red" @click="openExamPreview(scope.row)">预览考试</el-button>
                  <el-button type="text" size="small"  slot="reference" style="color:red" @click="openscoreAnalysis(scope.row)">统计分析</el-button>
                   <el-button type="text" size="small"  slot="reference" style="color:red" @click="openPaper(scope.row)">编辑试卷</el-button>
                    <el-button type="text" size="small"  slot="reference" style="color:red" @click="openmoniToring(scope.row)">考试监控</el-button>
                    <el-dropdown>
                        <span class="el-dropdown-link" style="color:red;font-size:12px;margin-left: 10px;cursor: pointer;font-weight: bold;">
                          更多<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="copyPaper(scope.row)">复制试卷</el-dropdown-item>
                          <el-dropdown-item @click.native="PrintingPaper(scope.row)">打印试卷</el-dropdown-item>
                          <el-dropdown-item @click.native="exportPaper(scope.row)">导出</el-dropdown-item>
                          <el-dropdown-item @click.native="deletPaper(scope.row)">删除试卷</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
             </template>
          </el-table-column>
            </el-table>
             <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
        </div>
              </div>
    </div>
</template>
<script>
import {getPaperList,listTree,editPapeItem,copyPa,getPaper} from "@/api/index/index"  //试卷列表、试卷分类、修改试卷、复制试卷、删除试卷
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    name:'testPaperList',
    components:{
      paginaTion
    },
          props: {
    topicID: [String, Number],
    importName: [String, Number],
    isAppId:[Boolean]
  },
    data() {
        return {
          opetion:[
            {
              id:1,
              name:'是'
            },
            {
               id:0,
              name:'否'
            }
          ],
          selsctarr:[],
           multipleSelection:[],
          catchStatus:false,
             currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            list:[],
            value:[],
            value1:[],
            itemList:[],
            search:'',
            search1:'',
            questionId:'',
            radio:'',
            radio1:'',
            questionId:''
        }
    },
    activated(){
        this.gethisInfo()
        this.getthisClass()
    },
    created () {
       this.questionId = this.topicID || ''
        this.gethisInfo()
        if(this.importName) this.getthisClass()
    },
    methods: {
               // 新增修改调用方法
        editfun(val){
            this.selsctarr = val        
        },
       // 新增修改调用清空方法
        remove(){
           this.multipleSelection = []
        },
         // 表格选择
         handleSelectionChange(val) {
           this.multipleSelection = val;
           this.$emit('sendStatus', this.multipleSelection,false)
         },
                // 手动选择
    onTableSelect(rows, row){
         this.catchStatus = rows.length && rows.indexOf(row) !== -1
    },
         getRowKeyOfTarget(row) {
            return row.id
            },
    // 复制试卷
    copyPaper(data){
 this.$prompt('请输入试卷名称', '复制试卷', {
          confirmButtonText: '复制',
          cancelButtonText: '取消',
          inputPattern:  /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
          inputErrorMessage: '请正确输入试卷名称'
        }).then(({ value }) => {
         let params = {
          id:data.id,
          paperName:value,
         }
         copyPa(params)
         .then(res =>{
          if(res.code == 0){
            this.$util.Notifi('复制成功','success','fa-check')
            this.currentPage = 1
            this.gethisInfo()
          }else{
            this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
          }
         })
        }).catch(() => {
          
        });
    },
    // 删除试卷
    deletPaper(data){
        this.$confirm('您确定要删除该试卷吗？删除后该试卷考试记录也会被删除，请您谨慎操作', '删除试卷', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
              }).then(() => {
                  getPaper({id:data.id},'DELETE')
                  .then(res =>{
                    this.$util.Notifi('删除成功','success','fa-check')
                   this.gethisInfo()
                  })
              }).catch(() => {          
              });
    },
      // 打开统计分析
      openscoreAnalysis(data){
        this.$router.push({
            name: "scoreAnalysis",
            query:{
                id:data.id,
            }
           })
      },
      // 打开考试监控
      openmoniToring(data){
        this.$router.push({
            name: "moniToring",
            query:{
                id:data.id,
            }
           })
      },
      // 打开预览考试
      openExamPreview(data){
        this.$router.push({
            name: "previewPaper",
            query:{
                id:data.id,
            }
           })
      },
      // 打开导出word页面
      exportPaper(data){
        this.$router.push({
            name: "ExportWord",
            query:{
                id:data.id,
            }
           })
      },
      // 打开打印试卷
      PrintingPaper(data){
        this.$router.push({
            name: "PrintingPaper",
            query:{
                id:data.id,
            }
           })
      },
      //打开新增试卷
      openPaper(data){
         this.$router.push({
            name: "addPaper",
            query:{
                id:data.id,
            }
           })
      },
          // 应用状态改变
    changeStatus(e){
     if(e.row.state == 1){
           this.$confirm('确认关闭吗？', '试卷禁用', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        this.editPaper(e)
                        }).catch(() => {          
                        });
        }else{
            this.editPaper(e)
        }
      },
       editPaper(e){
             editPapeItem({
                id:e.row.id,
                state:e.row.state == 1 ? '2' : '1',
                    },'put')
                .then(res => {
                  if(res.code ==1){
                     this.$message.error(res.msg); 
                  }else{
                      this.$message.success('状态修改成功'); 
                    this.gethisInfo()
                  }
                })
                .catch(err => {
                })
        },
        // 新增试卷
        addPaper(data){
            data.id ? this.$router.push({name:'addPaper',query:{id:data.id}}) : this.$router.push({name:'addPaper',query:{}})
        },
        // 重置
        reset(){
          this.search=""
          this.search1=""
          this.value=""
          this.value1=""
          this.radio1=""
          this.radio=""
          this.questionId = this.topicID || ''
          this.currentPage=1
          this.gethisInfo()
        },
        allradio(type){
          this.radio=""
          this.currentPage=1
          this.gethisInfo()
        },
        // 筛选
        classSelect(){
            this.currentPage = 1
            this.gethisInfo()
        },
        classSelect1(value){
              if(value){
                let index = value.length-1
                this.value = value[index]
            }else{
              this.value = ''
            }
            this.currentPage = 1
            this.gethisInfo()
        },
            emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisInfo()
      },
        // 获取试卷列表
        gethisInfo(){
            if(typeof(this.value) == "undefined") this.value = ""
             let params = {
                paperName:this.search ,
                id:this.search1,
                classifyId:this.value,
                state:this.radio1,
                validPeriod:this.radio,
                questionId:this.questionId,
                practiceMode:this.value1,
                current: this.currentPage,
                size:this.PageSize,
            }
            getPaperList(params)
            .then(res =>{
                this.list = res.data.records
             this.totalCount = res.data.total;
             if(this.importName){
              let rows = []
                         for (let m = 0; m < this.selsctarr.length; m++) {
                        for (let n = 0; n < this.list.length; n++) {
                        if (this.selsctarr[m].id === this.list[n].id || this.selsctarr[m].paperId === this.list[n].id) {
                            
                            rows.push(this.list[n])
                        }
                        }
                    }
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row,true)
                    })
             }
            })
            .catch(err =>{})
        },
             // 获取=试卷分类
        getthisClass(){
            this.itemList = []
             listTree({
                name:''
             })
            .then(res => {
              if(res.data !==null){
                for (const key in res.data) {
                  this.itemList.push({
                    value:res.data[key].id,
                    label:res.data[key].name,
                    children:res.data[key].children ? [] : ''
                  }) 
                  if(res.data[key].children){
                    for (const i in res.data[key].children) {
                        this.itemList[key].children.push({
                            value:res.data[key].children[i].id,
                            label:res.data[key].children[i].name
                        })
                    }
                  } 
                }
                console.log(this.itemList)
              }else{
                    this.itemList = []
             }

            })
            .catch(err => {
            })
        },
    },

}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-switch.is-disabled .el-switch__core {
    cursor: pointer !important;
    width: 50px !important;
  }
       .el-dialog{
      
            .el-dialog__header{
                background: #ccc;
               border-radius: 2px 2px 0 0;
            }
        }
                .dia-can{
        .canvas{
            position:relative !important;
            top: 0 !important;
            display: block;
            margin: 0 auto;
        }
    }
           .dia-btn{
            width: 100px;
        	height: 32px;
				line-height: 30px;
				font-size: 14px;
				padding: 0 16px;
				border-radius: 2px;
				font-family: inherit;
				border-width: 1px;
				border-style: solid;
				text-align: center;
				vertical-align: middle;
				box-sizing: border-box;
				cursor: pointer;
				transition: all .3s;
				background: $base-color-btn;
				color: #fff;
                margin: 20px auto;
                margin-bottom: 0;
    }

}
</style>